module.exports = __webpack_public_path__ + "img/main_banner_02.563ea14.webp";